import {useRouter} from 'vue-router';
import type {Router} from 'vue-router';

/**
 * When the walkthrough store runs outside a component (e.g. Pinia unit tests),
 * useRouter() has no injection context. Tests register the memory router here;
 * production leaves this unset.
 */
let navRouterOverride: Router | null = null;

export function setWalkthroughNavRouterForTests(router: Router | null): void {
  navRouterOverride = router;
}

export function resolveWalkthroughNavRouter(): Router | undefined {
  if (navRouterOverride) return navRouterOverride;
  try {
    return useRouter();
  } catch {
    return undefined;
  }
}
